import axiosInstance from "../utils/axiosConfig";
import { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Card } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import MentorLifeTopicUpload from "./MentorLifeTopicUpload";


export default function LifeTopics(props) {
    const { user, theme, showNotification } = props;
    
    const useStyles = makeStyles({
        root: {
            minWidth: 275,
            minHeight: 500,
        },
        lifeTopicCard: {
            width: '100%',          // Take full width of grid item
            minHeight: 200,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '16px',   // Add bottom margin for spacing
        },
        videoCardContainer: {
            width: '100%',          // Take full width
            maxHeight: 135,
            marginBottom: '8px',    // Space between video and text
        },
        input: {
            height: "500px",
            resize: "none",
        },
        title: {
            fontSize: 32,
            fontFamily: "GoodUnicorn",
            color: theme.primaryColor
        },
        playIcon: {
            color: theme.primaryColor,
            cursor: "pointer",
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        mentorUploadContainer: {
            padding: "20px 0",
            maxWidth: "800px",
            margin: "0 auto",
        },
        // Add this new class
        homeGrid: {
            "&::before": {
                content: "' '",
                background: `url(${theme.backgroundLogo}) no-repeat center center fixed`,
                opacity: ".6",
                backgroundSize: "cover",
                position: "absolute",
                top: "160px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                zIndex: -1
            }
        }
    });
    
    const [lifeTopics, setLifeTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Check if user is mentor
    const isMentor = user?.roles?.some(role => role.name === "mentor") || user?.isMentor;
    
    useEffect(() => {
        fetchLifeTopics();
    }, []);
    
    const fetchLifeTopics = async () => {
        try {
            setLoading(true);
            const result = await axiosInstance.get(`/life_topics`);
            setLifeTopics(result.data);
        } catch (error) {
            console.error("Error fetching life topics:", error);
            if (showNotification) {
                showNotification("Failed to load life topics", "error");
            }
        } finally {
            setLoading(false);
        }
    };
    
    const handleTopicAdded = (newTopic) => {
        // Refresh the list after adding a new topic
        fetchLifeTopics();
    };
    
    const classes = useStyles();
    
    const options = { year: "numeric", month: "long", day: "numeric" };
    
    return (
        <div className={classes.homeGrid}>
            <Grid container spacing={2}>
                <Grid item xs={1} />
                <Grid className={classes.title} item xs={1} style={{ marginTop: "2rem" }}>
                    Life Topics
                </Grid>
                
                {/* Mentor Upload Section - Only visible to mentors */}
                {isMentor && (
                    <Grid item xs={10} className={classes.mentorUploadContainer}>
                        <MentorLifeTopicUpload 
                            theme={theme} 
                            showNotification={showNotification}
                            onSuccess={handleTopicAdded}
                        />
                    </Grid>
                )}
                
                <Grid container justifyContent="left" xs={11} spacing={5} style={{ marginLeft: "4rem" }}>
                    {loading ? (
                        <Grid item xs={12}>
                            <Typography variant="body1">Loading life topics...</Typography>
                        </Grid>
                    ) : lifeTopics.length === 0 ? (
                        <Grid item xs={12}>
                            <Typography variant="body1">No life topics available</Typography>
                        </Grid>
                    ) : (
                        lifeTopics.map((topic, index) => (
                            <Grid item xs={3} key={topic.id || index}>
                                <div className={classes.lifeTopicCard}>
                                    <Card className={classes.videoCardContainer}>
                                        <div
                                            style={{
                                                position: "relative",
                                                paddingBottom: "56.25%",
                                                height: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <iframe
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    overflow: "hidden",
                                                }}
                                                type="text/html"
                                                src={topic.url}
                                                width="100%"
                                                height="100%"
                                                allowFullScreen
                                                title={`Life Topic ${index + 1}`}
                                            />
                                        </div>
                                    </Card>
                                    
                                    <div style={{ textAlign: "left" }}>
                                        <span>
                                            <b>{topic.name}</b>
                                        </span>
                                        <br />
                                        <span>
                                            {new Date(topic.created_at).toLocaleDateString(
                                                "en-US",
                                                options
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        ))
                    )}
                </Grid>
            </Grid>
        </div>
    );
}